import { useEffect } from 'react';

const LogoutPage = () => {
  useEffect(() => {
    window.location.href = `${process.env.REACT_APP_BACKEND}/auth/logout${window.location.search}`;
  }, []);
};
export default LogoutPage;
